module.exports = __webpack_public_path__ + "img/pgd_a_10100.4d3ec492.png";